import type { ChangeEvent } from 'react'
import { forwardRef, useEffect, useState } from 'react'

import CloseIcon from '@/assets/icons/icon-close.svg'
import SearchIcon from '@/assets/icons/icon-search.svg'
import { TextField } from '@/components/ui/text-field.tsx'
import { classNames } from '@/utils/helpers.ts'

interface HeaderButtonsProps {
  placeholder?: string
  value?: string
  onInputChange?: (value: string) => void
  id?: string
  className?: string
  testId?: string
}

export const SearchInput = forwardRef<HTMLInputElement, HeaderButtonsProps>(
  (props, ref) => {
    const { placeholder, value, onInputChange, className } = props

    const [inputValue, setInputValue] = useState<string>('')

    useEffect(() => {
      setInputValue(value ?? '')
    }, [value])

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value)
      onInputChange?.(event.target.value)
    }

    return (
      <TextField
        id={props.id}
        prefix={
          <SearchIcon
            className="text-title peer-focus:text-primary-500 flex-shrink-0"
            width={12}
            height={12}
          />
        }
        suffix={
          !!inputValue && (
            <CloseIcon
              onClick={() => {
                setInputValue('')
                onInputChange?.('')
              }}
              className="cursor-pointer hover:text-primary-500"
            />
          )
        }
        placeholder={placeholder}
        className={classNames('w-56', className)}
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        ref={ref}
        testId={props.testId ?? 'search-input'}
      />
    )
  },
)

SearchInput.displayName = 'SearchInput'
